import styled from 'styled-components';

import { theme } from '../../../../common/ui/theme';

export const ContentWrapper = styled.div`
    width: 334px;
    background-color: ${theme.colors.background.default};
    box-shadow: ${theme.shadows.large};
    border-radius: ${theme.radii[4]};
    outline: none;
`;
